import React from 'react'
import { Container } from 'react-bootstrap'
import jojo from './../assest/images/Home/jojo.jpg'
import './../assest/style/aboutus.css'

import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import certi from './../assest/images/projectss/certification/uni.png'
const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
      padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
      padding: theme.spacing(1),
    },
  }));
  
export const Aboutus = () => {

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
      setOpen(true);
    };
    const handleClose = () => {
      setOpen(false);
    };
  return (
    <div className='aboutus'>
        <Container>
            <div className='row'>
            <div className='col-lg-6 col-md-12 col-sm-12 one'>
                <h5>About me</h5>
                <h2>Digital Creative Professional</h2>
                <p> 7 YEARS OF EXPERIENCE</p>
                     <div className='personalinfo'>
                        <div className='biograph'> Biography</div>
                        <div className='row'>
                     
                            <div className='col-lg-6 col-md-6 col-sm-12'>
                                <h3>Name</h3>
                                <h4>Jaafar Homam Ahmad</h4>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12'>
                                <h3>Birthday</h3>
                                <h4>30jan,1993</h4>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-lg-6 col-md-6 col-sm-12'>
                                <h3>Email</h3>
                                <h4>jaafarhomamahmad@gmail.com</h4>
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12'>
                                <h3>Phone</h3>
                                <h4>+963 991759647</h4>
                            </div>
                        </div>
                     </div>
                     <div className='education'>
                        <h4>Education</h4>
                        <h2>Bachelor's degree in Information Technology</h2>
                        <h5>Syrian Virtual University</h5>
                        <h3>2012 / 2018</h3>

                        <React.Fragment>
      <Button variant="outlined" onClick={handleClickOpen}>
     View certification
      </Button>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        University degree
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Typography gutterBottom>
    <img src={certi} className="certt"/>
          </Typography>

    
        </DialogContent>
        <DialogActions>
    
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
                     </div>
            </div>
            <div className='col-lg-6 col-md-12 col-sm-12 two'>
               
               
                <div className='section d-flex'>
                 <div className='square'> 2023 / <br/>Now</div>
                 <div className='texty'>
            <h2>Graphic Designer</h2>
                        <h5>Zen Diamond-Iraq</h5>
                        </div>
                        </div>

                        <div className='section  d-flex'>
                        <div className='square'>2022 / <br/>2023</div> 
                        <div className='texty'>
            <h2>Digital MARKETING SPECIALIST</h2>
                        <h5>Roomy Dubai</h5>
                     </div>
                        </div>

                        <div className='section  d-flex'>
                        <div className='square'>2021 / <br/>2022 </div>
                        <div className='texty'>
            <h2>Digital MARKETING MANAGER</h2>
                        <h5>Makki Company</h5>
                     </div>
                        </div>
                        <div className='section  d-flex'>
                        <div className='square'>2017 / <br/> 2022</div>
                        <div className='texty'>
            <h2>Social Media Specialist</h2>
                        <h5>Muath Limited Group-USA</h5>
                       
                        </div>
                        </div>
                        <div className='section  d-flex'>
                        <div className='square'>2017 / <br/>Now </div>
                        <div className='texty'>
            <h2>DIGITAL CREATIVE PROFFESIONAL</h2>
                        <h5>Freelance</h5>
                       
                        </div>
                        </div>
            </div>
            </div>
        </Container>
    </div>
  )
}
